import { observer } from 'mobx-react';
import { CostBreakdownTooltip } from 'common/tooltips';
import React from 'react';

const CarrierServiceDeliveryDateAndRateOption = ({
	data: {
		extra,
		extra: {
			deliveryTimestamp,
			rateComposition: { cost, surcharge, total },
			carrier,
			rateId,
		},
		value,
	},
}) => {
	// ShipStation rates are carrier-less (no carrier object, no surcharge). Guard every carrier deref.
	const carrierId = carrier ? carrier.id : '';
	return (
		<React.Fragment>
			{carrier != null && carrier.surplusCharge != null && (
				<CostBreakdownTooltip
					idValue={`${value}${carrierId}${rateId != null ? `-${rateId}` : ''}`}
					shippingCost={cost}
					surplusCharge={surcharge}
					total={total}
					displayIcon={true}
				/>
			)}
			{/* Right-anchor the date so the label/badge pack left (space-between otherwise centers short labels,
			    e.g. carrier-less ShipStation rates with no delivery date). */}
			<span style={{ marginLeft: 'auto' }}>{deliveryTimestamp}</span>
		</React.Fragment>
	);
};

export default observer(CarrierServiceDeliveryDateAndRateOption);
